export const trendElements = [
  'EFDH',
  'EMDH',
  'EPDH',
  'UF',
  'UDF',
  'EUF',
  'FOF',
  'FOH',
  'GOF',
  'EMOF',
  'SR',
  'NOF',
  'EFOR',
  'MOF',
  'AF',
  'ESOF',
  'DEH',
  'POF',
  'MOH',
  'EUOF',
  'POH',
  'FOR',
  'EAF',
  'GCF',
  'EMOR',
  'UOF',
  'EFORD',
  'EPOR',
  'NCF',
  'MEH',
  'SEDF',
  'EUOR',
  'EPDHRS',
  'SEH',
]
